import axiosInstance from './axios.config';

const API_URL = import.meta.env.VITE_API_URL;

export const memberareaService = {
  // Dashboard
  getDashboardData: async () => {
    const response = await axiosInstance.get('/memberarea/dashboard');
    return response.data;
  },

  // Mon cheptel
  getHerd: async () => {
    const response = await axiosInstance.get('/memberarea/herd');
    return response.data;
  },

  // Projets disponibles
  getAvailableProjects: async () => {
    const response = await axiosInstance.get('/memberarea/available-projects');
    return response.data;
  },

  // Détails d'un projet
  getProjectDetails: async (id) => {
    const response = await axiosInstance.get(`/memberarea/projects/${id}`);
    return response.data;
  },

  // Souscrire à un plan
  subscribeToPlan: async (planId) => {
    const response = await axiosInstance.post('/memberarea/subscribe', { planId });
    return response.data;
  },

  // Profil utilisateur
  getProfile: async () => {
    const response = await axiosInstance.get('/memberarea/profile');
    return response.data;
  },

  getProfileDetails: async () => {
    const response = await axiosInstance.get('/memberarea/profile/details');
    return response.data;
  },

  updateProfile: async (profileData) => {
    const response = await axiosInstance.put('/memberarea/profile', profileData);
    return response.data;
  },

  // Panier
  getCart: async () => {
    const user = JSON.parse(localStorage.getItem('user'));
    
    // Si l'utilisateur n'est pas connecté, retourner le panier temporaire
    if (!user?.token) {
      const tempCart = JSON.parse(localStorage.getItem('tempCart') || '[]');
      return {
        success: true,
        data: {
          items: tempCart
        }
      };
    }
    
    // Si l'utilisateur est connecté, procéder normalement
    const response = await axiosInstance.get('/memberarea/cart');
    return response.data;
  },

  getFundingStats: async () => {
    const response = await axiosInstance.get('/memberarea/funding-stats');
    return response.data;
  },

  createMembershipPayment: async () => {
    const response = await axiosInstance.post('/memberarea/membership/payment');
    return response.data;
  },

  verifyMembershipPayment: async (sessionId) => {
    const response = await axiosInstance.get(`/memberarea/membership/verify/${sessionId}`);
    return response.data;
  },

  async getHerdData() {
    try {
      const response = await axiosInstance.get('/memberarea/herd');
      return response.data;
    } catch (error) {
      console.error('Error fetching herd data:', error);
      throw error;
    }
  },

  createDonation: async (amount) => {
    console.log('Service: Création d\'un don authentifié avec montant:', amount);
    try {
      // Construire l'URL de redirection complète
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/donate/redirect`;
      console.log('URL de redirection:', redirectUrl);
      
      const response = await axiosInstance.post('/memberarea/donation/payment', { 
        amount,
        redirectUrl 
      });
      console.log('Service: Réponse de createDonation:', response.data);
      return response.data;
    } catch (error) {
      console.error('Service: Erreur dans createDonation:', error);
      throw error;
    }
  },

  verifyDonation: async (sessionId) => {
    console.log('Service: Appel à verifyDonation avec sessionId:', sessionId);
    try {
      const response = await axiosInstance.get(`/memberarea/donation/verify/${sessionId}`);
      console.log('Service: Réponse de verifyDonation:', response.data);
      return response.data;
    } catch (error) {
      console.error('Service: Erreur dans verifyDonation:', error);
      throw error;
    }
  },

  getPlanDetails: async (planId) => {
    const response = await axiosInstance.get(`/memberarea/plan/${planId}`);
    if (response.data) {
      return response.data;
    }
    throw new Error('Impossible de récupérer les détails du plan');
  },

  // Ajouter au panier
  addToCart: async (projectId, isGift = false, beneficiaryInfo = null) => {
    const user = JSON.parse(localStorage.getItem('user'));
    
    // Si l'utilisateur n'est pas connecté, sauvegarder dans le panier temporaire
    if (!user?.token) {
      const tempCart = JSON.parse(localStorage.getItem('tempCart') || '[]');
      const cartItem = {
        projectId,
        isGift,
        beneficiaryInfo,
        addedAt: new Date().toISOString()
      };
      
      tempCart.push(cartItem);
      localStorage.setItem('tempCart', JSON.stringify(tempCart));
      
      return {
        success: true,
        message: 'Ajouté au panier temporaire'
      };
    }

    // Si l'utilisateur est connecté, procéder normalement
    const payload = {
      projectId,
      isGift
    }

    if (isGift && beneficiaryInfo) {
      payload.beneficiaryInfo = beneficiaryInfo
    }

    const response = await axiosInstance.post('/memberarea/cart/add', payload);
    return response.data;
  },

  // Supprimer du panier
  removeFromCart: async (itemId) => {
    const response = await axiosInstance.delete(`/memberarea/cart/remove/${itemId}`);
    return response.data;
  },

  // Mettre à jour le panier
  updateCart: async (itemId, quantity) => {
    const response = await axiosInstance.put(`/memberarea/cart/update/${itemId}`, {
      quantity
    });
    return response.data;
  },

  // Checkout du panier
  checkoutCart: async () => {
    const response = await axiosInstance.post('/memberarea/cart/checkout');
    return response.data;
  },

  // Vérification du paiement
  verifyCartPayment: async (sessionId) => {
    const response = await axiosInstance.get(`/memberarea/cart/verify/${sessionId}`);
    return response.data;
  },

  async getInvoices() {
    try {
      const response = await axiosInstance.get('/memberarea/invoices');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Récupérer la liste des pays
  async getCountries() {
    try {
      const response = await axiosInstance.get('/public/countries')
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Créer un paiement d'adhésion public
  async createPublicMembershipPayment(formData) {
    try {
      const response = await axiosInstance.post('/public/membership/payment', formData)
      return response.data
    } catch (error) {
      throw error
    }
  },

  // Vérifier le paiement d'adhésion public
  async verifyPublicMembershipPayment(sessionId) {
    try {
      const response = await axiosInstance.get(`/public/membership/verify/${sessionId}`)
      return response.data
    } catch (error) {
      throw error
    }
  },

  async verifyEmail(token) {
    try {
      const response = await axiosInstance.get(`/verify-email/${token}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Créer un don public (sans être connecté)
  async createPublicDonation(donationData) {
    console.log('Service: Création d\'un don public avec données:', donationData);
    try {
      // Construire l'URL de redirection complète
      const baseUrl = window.location.origin;
      const redirectUrl = `${baseUrl}/donate/redirect`;
      console.log('URL de redirection:', redirectUrl);
      
      const response = await axiosInstance.post('/public/donation/payment', {
        ...donationData,
        redirectUrl
      });
      console.log('Service: Réponse de createPublicDonation:', response.data);
      return response.data;
    } catch (error) {
      console.error('Service: Erreur dans createPublicDonation:', error);
      throw error;
    }
  },

  // Vérifier un don public
  async verifyPublicDonation(sessionId) {
    console.log('Service: Appel à verifyPublicDonation avec sessionId:', sessionId);
    try {
      const response = await axiosInstance.get(`/public/donation/verify/${sessionId}`);
      console.log('Service: Réponse de verifyPublicDonation:', response.data);
      return response.data;
    } catch (error) {
      console.error('Service: Erreur dans verifyPublicDonation:', error);
      throw error;
    }
  },

  // Paiement par chèque
  async checkPayment(items) {
    try {
      const response = await axiosInstance.post('/memberarea/check-payment', items);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  // Mettre à jour le nom d'un plan dans le panier
  async updatePlanName(planId, name) {
    try {
      const response = await axiosInstance.put(`/memberarea/cart/${planId}/name`, { name });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async updateHerdPlanName(planId, name) {
    try {
      const response = await axiosInstance.put(`/memberarea/herd/${planId}/name`, {
        name: name
      });
      return response.data;
    } catch (error) {
      console.error('Error updating plan name:', error);
      throw error;
    }
  }
}; 